import React from "react";

import { CurrentPoint } from "@/components/domains";
import { Button, SelectorOption } from "@/components/inputs";
import { ProductModel } from "@/models/product/type";

import { QuantitySelectorPanel } from "./QuantitySelectorPanel";

interface ProductDetailSelectsProps {
  isMobile: boolean;
  product: ProductModel;
  hasDifferentSalesTypeInCart: boolean;
  quantity: number;
  quantityOptions: SelectorOption<number>[];
  setQuantity: (quantity: number) => void;
  handleClickDirect: () => void;
  firstSubscriptionSubtotal: number;
  afterSecondSubscriptionSubtotal: number;
  normalSubtotal: number;
  isDisabledSubmitDirect: boolean;
}

export function ProductDetailSelectsOutlet({
  isMobile = false,
  product,
  hasDifferentSalesTypeInCart,
  quantity,
  quantityOptions,
  setQuantity,
  handleClickDirect,
  firstSubscriptionSubtotal,
  afterSecondSubscriptionSubtotal,
  normalSubtotal,
  isDisabledSubmitDirect,
}: ProductDetailSelectsProps): React.ReactNode {
  return (
    <div>
      <CurrentPoint />
      <QuantitySelectorPanel
        isMobile={isMobile}
        quantity={quantity}
        options={quantityOptions}
        onChange={setQuantity}
        unit={product.meal}
        firstSubscriptionPrice={firstSubscriptionSubtotal}
        afterSecondSubscriptionPrice={afterSecondSubscriptionSubtotal}
        normalPrice={normalSubtotal}
      />

      <Button
        variants="secondary"
        rounded
        fullWidth
        disabled={isDisabledSubmitDirect || hasDifferentSalesTypeInCart}
        onClick={handleClickDirect}
        className="mg__top__s"
      >
        いますぐ購入
      </Button>

      {hasDifferentSalesTypeInCart && (
        <div className="text__s text__bold text__red mg__bottom__s mg__top__s text__center text__left__pc">
          アウトレット商品と通常商品を同時に購入することはできません。カートの中身をご確認ください。
        </div>
      )}
    </div>
  );
}
